<template>
	<div class="row h-100">
		<div class="col-12 col-lg mb-4">
			<div class="title mb-4">
				Буду оплачивать как:
			</div>

			<div class="row">
				<div
					v-for="type in TABS"
					:key="`type-${type.id}`"
					class="col-12 col-md mb-2 mb-md-0"

					@click="payerHandler(type.value)"
				>
					<div
						class="payer-card"
						:class="{
							active: type.value === payerType,
						}"
					>
						<div class="payer-card__icon" :class="[type.icon]" />
						<div class="strong">
							{{ type.label }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="col-12 order-7 mt-auto d-flex justify-content-start">
			<div class="w-100 d-flex">
				<FormulateInput
					type="submit"
					class="submit mb-2 w-100"
					@click="submitHandler"
				>
					<span>Продолжить</span>
				</FormulateInput>
			</div>
		</div>
	</div>
</template>

<script>
import { FORM_PAYER_TYPE } from '~/utils/dictionaries';
import paymentFormMixin from '~/mixins/paymentFormMixin';
import {
	mapGetters, mapMutations, mapActions, mapState,
} from 'vuex';

export default {
	name: 'PayerStep',
	mixins: [paymentFormMixin],
	props: {
		block: { type: Object, required: true },
		order: { type: Object, default: () => ({}) },
	},

	computed: {
		...mapState('scenarios/paymentForm', ['orderHash']),

		...mapGetters('scenarios/paymentForm', [
			'payerType',
			'isPhysicalPayer',
		]),
	},
	created() {
		this.checkStorage();
	},
	methods: {
		...mapMutations('scenarios/paymentForm', [
			'setPayerType',
			'setStep',
		]),
		...mapActions('scenarios/paymentForm', [
			'setCurrentStep',
		]),
		payerHandler(value) {
			this.setPayerType(+value);

			if (this.checkOrderHashAndReset()) {
				// Если отображается модальное окно сброса - вернуть значение к предыдущему
				const { URIDIC, PHYSICAL } = FORM_PAYER_TYPE;
				this.$nextTick(() => {
					this.setPayerType(this.isPhysicalPayer ? URIDIC : PHYSICAL);
				});
			}
		},
		submitHandler() {
			this.setCurrentStep(this.STEPS.INFO);

			if (!this.orderHash) this.$auth.$storage.setLocalStorage(`payerType-${this.block.id}`, this.payerType);
		},
		checkStorage() {
			const data = this.$auth.$storage.getLocalStorage(`payerType-${this.block.id}`);

			if (data && !this.orderHash) {
				this.setPayerType(+data);
				this.setStep(this.STEPS.INFO);
			}
		},
	},

};
</script>

<style lang="scss" scoped>
@import '~/assets/styles/sk_variables';
@import "~/assets/styles/bootstrap/scss/functions";
@import "~/assets/styles/bootstrap/scss/variables";
@import "~/assets/styles/bootstrap/scss/mixins";

.payer-card {
	height: 100%;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;

	gap: 0.5rem;
	padding: 1.5rem 1rem;

	background-color: $theme-lightblue;

	&.active, &:hover {
		background-color: $primary;
		color: $white;

		& > * {
			color: $white;
		}
	}

	&__icon {
		font-size: 2.5rem;
		color: $primary;
	}
}
</style>
